import { Controller } from "@hotwired/stimulus"
import { baseKit } from "../shared/browserKit"

export default baseKit(({})=>{
  return class HelloController extends Controller {
    // usage
    // static targets = [ "item" ]
    // itemTargetConnected(){}
    // itemTargetDisconnected(){}
    // this.itemTarget
    // this.viewTargets
    static targets = [
      "item",
    ]

    // usage
    // static values = { itemColor: { type: String, default: "white" } }
    // this.itemColorValue
    // this.itemColorValue = "red"
    // itemColorValueChanged(){}
    static values = {
      itemColor: { type: String, default: "white" },
    }
  
    connect() {
      const rootController = this
      const rootElement = this.element
      console.log("hello_controller.js", { rootController, rootElement })
    }

    handleItemClick = function(event){
      console.log(
        "item! event, target, rootElement", 
        event, 
        this, 
        this.element,
      )
    }.bind(this)

    itemTargetConnected (element){
      element.addEventListener("click", this.handleItemClick)
    }
  }
})
